const config = {
  API_BASE_URL: 'https://axoplan.com:5001',
  //API_BASE_URL: 'http://localhost:5001',
  UPLOAD_URL: 'https://storageaxo.blob.core.windows.net/profile-pictures',
}
export default config
